import { render, staticRenderFns } from "./TenderHead.vue?vue&type=template&id=00cb39f6&scoped=true&"
import script from "./TenderHead.vue?vue&type=script&lang=js&"
export * from "./TenderHead.vue?vue&type=script&lang=js&"
import style0 from "./TenderHead.vue?vue&type=style&index=0&id=00cb39f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cb39f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00cb39f6')) {
      api.createRecord('00cb39f6', component.options)
    } else {
      api.reload('00cb39f6', component.options)
    }
    module.hot.accept("./TenderHead.vue?vue&type=template&id=00cb39f6&scoped=true&", function () {
      api.rerender('00cb39f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/TenderHead.vue"
export default component.exports